import { Skeleton } from "./ui/skeleton";

export function DashboardLayoutSkeleton() {
  return (
    <div className="flex min-h-screen bg-background">
      {/* Sidebar skeleton */}
      <div className="w-[280px] border-r border-border bg-background p-4 space-y-6">
        {/* Logo area */}
        <div className="flex items-center gap-3 px-2">
          <Skeleton className="h-8 w-8 rounded-md animate-shimmer" />
          <Skeleton className="h-4 w-24 animate-shimmer" />
        </div>

        {/* Company Selector */}
        <div className="px-2">
          <Skeleton className="h-10 w-full rounded-lg animate-shimmer" />
        </div>

        {/* Navigation Menu items */}
        <div className="space-y-1 px-2">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="flex items-center gap-3 px-3 py-2">
              <Skeleton className="h-5 w-5 animate-shimmer" />
              <Skeleton className="h-4 w-32 animate-shimmer" />
            </div>
          ))}
        </div>

        {/* User profile area at bottom */}
        <div className="absolute bottom-4 left-4 right-4">
          <div className="flex items-center gap-3 px-1">
            <Skeleton className="h-9 w-9 rounded-full animate-shimmer" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-3 w-20 animate-shimmer" />
              <Skeleton className="h-2 w-32 animate-shimmer" />
            </div>
          </div>
        </div>
      </div>

      {/* Main content skeleton */}
      <div className="flex-1 p-4 md:p-6 lg:p-8 space-y-6">
        {/* Header */}
        <div className="space-y-2">
          <Skeleton className="h-8 w-64 animate-shimmer" />
          <Skeleton className="h-4 w-96 animate-shimmer" />
        </div>

        {/* Action buttons */}
        <div className="flex gap-2">
          <Skeleton className="h-10 w-32 animate-shimmer" />
          <Skeleton className="h-10 w-28 animate-shimmer" />
        </div>

        {/* Content cards */}
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {[...Array(6)].map((_, i) => (
            <Skeleton key={i} className="h-32 rounded-xl animate-shimmer" />
          ))}
        </div>

        {/* Main content area */}
        <Skeleton className="h-96 rounded-xl animate-shimmer" />
      </div>
    </div>
  );
}
